import React, { useState, useEffect } from 'react';

const SearchBar = ({ value = '', onChange, onSearch, placeholder = "Search..." }) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  // Update debouncedValue when value prop changes
  useEffect(() => {
    setDebouncedValue(value);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setDebouncedValue(newValue);
    
    if (onChange) {
      onChange(newValue);
    }

    // Debounce search
    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      onSearch(newValue);
    }, 500);
  };

  const handleClear = () => {
    setDebouncedValue('');
    
    if (onChange) {
      onChange('');
    }
    
    onSearch('');
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={debouncedValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full px-4 py-2 border rounded-lg
                 border-[#E6CCB2] bg-white/80 backdrop-blur-sm
                 text-[#2E1F27] placeholder-[#9B7E6B]
                 focus:outline-none focus:ring-2 focus:ring-[#B85C38]
                 transition-all duration-300 ease-in-out"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3">
        {debouncedValue ? (
          <button 
            onClick={handleClear}
            className="mr-2 text-[#9B7E6B] hover:text-[#2E1F27]"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        ) : null}
        <svg
          className="w-5 h-5 text-[#9B7E6B]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </div>
  );
};

export default SearchBar;